"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3792],{

/***/ 73348:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ P; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50066);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-style: normal;\n  font-size: 16px;\n  line-height: 140%;\n  color: ",
        ";\n  margin: 12px 0;\n\n  @media ",
        " {\n    font-size: 18px;\n    line-height: 160%;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 400;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: Avenir_black !important;\n  font-weight: 700 !important;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 400;\n  font-style: italic;\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 300;\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 140%;\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}



const BaseP = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-ad764eed-0"
})(_templateObject(), (param)=>{
    let { theme , color  } = param;
    return theme.colors[color].normal;
}, (param)=>{
    let { theme  } = param;
    return theme.devices.tablet;
});
const StyledP = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(BaseP).withConfig({
    componentId: "sc-ad764eed-1"
})(_templateObject1());
const StyledPBold = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(BaseP).withConfig({
    componentId: "sc-ad764eed-2"
})(_templateObject2());
const StyledPItalic = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(BaseP).withConfig({
    componentId: "sc-ad764eed-3"
})(_templateObject3());
const StyledPLight = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(BaseP).withConfig({
    componentId: "sc-ad764eed-4"
})(_templateObject4());
const StyledHelperText = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(BaseP).withConfig({
    componentId: "sc-ad764eed-5"
})(_templateObject5());
function P(param) {
    let { variant ="regular" , color ="black" , children , ...rest } = param;
    switch(variant){
        case "bold":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledPBold, {
                ...rest,
                color: color,
                children: children
            });
        case "italic":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledPItalic, {
                ...rest,
                color: color,
                children: children
            });
        case "regular":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledP, {
                ...rest,
                color: color,
                children: children
            });
        case "light":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledPLight, {
                ...rest,
                color: color,
                children: children
            });
        case "helper":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledHelperText, {
                ...rest,
                color: color,
                children: children
            });
        default:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledP, {
                ...rest,
                color: color,
                children: children
            });
    }
}


/***/ }),

/***/ 47804:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_parseHTMLtoReact__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46290);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65906);




function regexReplace(text, searchString, highlightColor) {
    const regex = new RegExp("".concat(searchString), "gi");
    return text.replace(regex, '<span\n        className="font-heading"\n        style="color: '.concat(highlightColor, '; fontWeight: bold"\n      >\n        $&\n      </span>'));
}
const TitleWithHighlights = (param)=>{
    let { text , textToHighlight , headerElement ="h1" , color ="primary" , style , className  } = param;
    let newText = text;
    if (textToHighlight && Array.isArray(textToHighlight)) {
        textToHighlight.forEach((highlight)=>{
            newText = regexReplace(newText, highlight !== null && highlight !== void 0 ? highlight : "", "var(--color-pink)");
        });
    } else if (textToHighlight) {
        newText = regexReplace(newText, textToHighlight !== null && textToHighlight !== void 0 ? textToHighlight : "", "var(--color-pink)");
    }
    switch(headerElement){
        case "h1":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(___WEBPACK_IMPORTED_MODULE_3__.H1, {
                color: color,
                variant: "bold",
                style: style,
                className: className + " header-banner-title new-section-latest max-sm:hyphens-auto",
                lang: "nl",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: (0,_utils_parseHTMLtoReact__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(newText)
                })
            });
        case "h2":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(___WEBPACK_IMPORTED_MODULE_3__.H2, {
                color: color,
                variant: "bold",
                style: style,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: (0,_utils_parseHTMLtoReact__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(newText)
                })
            });
        case "h3":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(___WEBPACK_IMPORTED_MODULE_3__.H3, {
                color: color,
                variant: "bold",
                style: style,
                className: className,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: (0,_utils_parseHTMLtoReact__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(newText)
                })
            });
        case "h4":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(___WEBPACK_IMPORTED_MODULE_3__.H4, {
                color: color,
                variant: "bold",
                style: style,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: (0,_utils_parseHTMLtoReact__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(newText)
                })
            });
        case "h5":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(___WEBPACK_IMPORTED_MODULE_3__.H5, {
                color: color,
                variant: "bold",
                style: style,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: (0,_utils_parseHTMLtoReact__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(newText)
                })
            });
        case "h6":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(___WEBPACK_IMPORTED_MODULE_3__.H6, {
                color: color,
                variant: "bold",
                style: style,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: (0,_utils_parseHTMLtoReact__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(newText)
                })
            });
        default:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(___WEBPACK_IMPORTED_MODULE_3__.H1, {
                color: color,
                variant: "bold",
                style: style,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: (0,_utils_parseHTMLtoReact__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(newText)
                })
            });
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (TitleWithHighlights);


/***/ }),

/***/ 65906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H1": function() { return /* reexport */ H1; },
  "H2": function() { return /* reexport */ H2; },
  "H3": function() { return /* reexport */ H3; },
  "H4": function() { return /* reexport */ H4; },
  "H5": function() { return /* reexport */ H5; },
  "H6": function() { return /* reexport */ H6; },
  "P": function() { return /* reexport */ P/* default */.Z; },
  "J": function() { return /* reexport */ TitleWithHighlights/* default */.Z; }
});

// UNUSED EXPORTS: ColorSpan

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/typography/ColorSpan/ColorSpan.tsx



function ColorSpan(param) {
    let { variant ="secondary" , children  } = param;
    const { colors  } = useTheme();
    return /*#__PURE__*/ _jsx("span", {
        style: {
            color: colors[variant].normal
        },
        children: children
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
;// CONCATENATED MODULE: ./components/typography/H1/H1.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 32px;\n  line-height: 120%;\n  color: ",
        ";\n  font-style: normal;\n  margin: 12px 0;\n\n  @media ",
        " {\n    margin: 0 0 22px;\n    font-size: 48px;\n    line-height: 140%;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 700;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 400;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 300;\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}



const BaseH1 = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-a29f0fcb-0"
})(_templateObject(), (param)=>{
    let { theme , color  } = param;
    return theme.colors[color].normal;
}, (param)=>{
    let { theme  } = param;
    return theme.devices.tablet;
});
const StyledH1Bold = (0,styled_components_browser_esm/* default */.ZP)(BaseH1).withConfig({
    componentId: "sc-a29f0fcb-1"
})(_templateObject1());
const StyledH1 = (0,styled_components_browser_esm/* default */.ZP)(BaseH1).withConfig({
    componentId: "sc-a29f0fcb-2"
})(_templateObject2());
const StyledH1Light = (0,styled_components_browser_esm/* default */.ZP)(BaseH1).withConfig({
    componentId: "sc-a29f0fcb-3"
})(_templateObject3());
function H1(param) {
    let { variant ="regular" , color ="black" , children , ...rest } = param;
    switch(variant){
        case "bold":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledH1Bold, {
                color: color,
                ...rest,
                children: children
            });
        case "regular":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledH1, {
                color: color,
                ...rest,
                children: children
            });
        case "light":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledH1Light, {
                color: color,
                ...rest,
                children: children
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledH1, {
                color: color,
                ...rest,
                children: children
            });
    }
}

;// CONCATENATED MODULE: ./components/typography/H2/H2.tsx

function H2_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 24px;\n  line-height: 120%;\n  color: ",
        ";\n  font-style: normal;\n  margin: 12px 0;\n\n  @media ",
        " {\n    margin: 18px 0;\n    font-size: 42px;\n    line-height: 130%;\n  }\n"
    ]);
    H2_templateObject = function() {
        return data;
    };
    return data;
}
function H2_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 700;\n"
    ]);
    H2_templateObject1 = function() {
        return data;
    };
    return data;
}
function H2_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 400;\n"
    ]);
    H2_templateObject2 = function() {
        return data;
    };
    return data;
}
function H2_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 300;\n"
    ]);
    H2_templateObject3 = function() {
        return data;
    };
    return data;
}



const BaseH2 = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-4cb8d9d0-0"
})(H2_templateObject(), (param)=>{
    let { theme , color  } = param;
    return theme.colors[color].normal;
}, (param)=>{
    let { theme  } = param;
    return theme.devices.tablet;
});
const StyledH2Bold = (0,styled_components_browser_esm/* default */.ZP)(BaseH2).withConfig({
    componentId: "sc-4cb8d9d0-1"
})(H2_templateObject1());
const StyledH2 = (0,styled_components_browser_esm/* default */.ZP)(BaseH2).withConfig({
    componentId: "sc-4cb8d9d0-2"
})(H2_templateObject2());
const StyledH2Light = (0,styled_components_browser_esm/* default */.ZP)(BaseH2).withConfig({
    componentId: "sc-4cb8d9d0-3"
})(H2_templateObject3());
function H2(param) {
    let { variant ="regular" , color ="black" , children , ...rest } = param;
    switch(variant){
        case "bold":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledH2Bold, {
                color: color,
                ...rest,
                children: children
            });
        case "regular":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledH2, {
                color: color,
                ...rest,
                children: children
            });
        case "light":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledH2Light, {
                color: color,
                ...rest,
                children: children
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledH2, {
                color: color,
                ...rest,
                children: children
            });
    }
}

;// CONCATENATED MODULE: ./components/typography/H3/H3.tsx

function H3_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 32px !important;\n  line-height: 120%;\n  color: ",
        ";\n  font-style: normal;\n  margin: 12px 0;\n"
    ]);
    H3_templateObject = function() {
        return data;
    };
    return data;
}
function H3_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 700;\n"
    ]);
    H3_templateObject1 = function() {
        return data;
    };
    return data;
}
function H3_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 400;\n"
    ]);
    H3_templateObject2 = function() {
        return data;
    };
    return data;
}
function H3_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 300;\n"
    ]);
    H3_templateObject3 = function() {
        return data;
    };
    return data;
}



const BaseH3 = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-36c5e31d-0"
})(H3_templateObject(), (param)=>{
    let { theme , color  } = param;
    return theme.colors[color].normal;
});
const StyledH3Bold = (0,styled_components_browser_esm/* default */.ZP)(BaseH3).withConfig({
    componentId: "sc-36c5e31d-1"
})(H3_templateObject1());
const StyledH3 = (0,styled_components_browser_esm/* default */.ZP)(BaseH3).withConfig({
    componentId: "sc-36c5e31d-2"
})(H3_templateObject2());
const StyledH3Light = (0,styled_components_browser_esm/* default */.ZP)(BaseH3).withConfig({
    componentId: "sc-36c5e31d-3"
})(H3_templateObject3());
function H3(param) {
    let { variant ="regular" , color ="black" , children , ...rest } = param;
    switch(variant){
        case "bold":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledH3Bold, {
                color: color,
                ...rest,
                children: children
            });
        case "regular":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledH3, {
                color: color,
                ...rest,
                children: children
            });
        case "light":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledH3Light, {
                color: color,
                ...rest,
                children: children
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledH3, {
                color: color,
                ...rest,
                children: children
            });
    }
}

;// CONCATENATED MODULE: ./components/typography/H4/H4.tsx

function H4_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        '\n  font-size: 24px;\n  line-height: 115% !important;\n  color: var(--color-black);\n  font-style: normal;\n  margin: 12px 0;\n  font-family: "Fjalla One";\n'
    ]);
    H4_templateObject = function() {
        return data;
    };
    return data;
}
function H4_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 700;\n"
    ]);
    H4_templateObject1 = function() {
        return data;
    };
    return data;
}
function H4_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 400;\n"
    ]);
    H4_templateObject2 = function() {
        return data;
    };
    return data;
}
function H4_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 300;\n"
    ]);
    H4_templateObject3 = function() {
        return data;
    };
    return data;
}



const BaseH4 = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-e18f6e3b-0"
})(H4_templateObject());
const StyledH4Bold = (0,styled_components_browser_esm/* default */.ZP)(BaseH4).withConfig({
    componentId: "sc-e18f6e3b-1"
})(H4_templateObject1());
const StyledH4 = (0,styled_components_browser_esm/* default */.ZP)(BaseH4).withConfig({
    componentId: "sc-e18f6e3b-2"
})(H4_templateObject2());
const StyledH4Light = (0,styled_components_browser_esm/* default */.ZP)(BaseH4).withConfig({
    componentId: "sc-e18f6e3b-3"
})(H4_templateObject3());
function H4(param) {
    let { variant ="regular" , children , color ="black" , ...rest } = param;
    switch(variant){
        case "bold":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledH4Bold, {
                color: color,
                ...rest,
                children: children
            });
        case "regular":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledH4, {
                color: color,
                ...rest,
                children: children
            });
        case "light":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledH4Light, {
                color: color,
                ...rest,
                children: children
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledH4, {
                color: color,
                ...rest,
                children: children
            });
    }
}

;// CONCATENATED MODULE: ./components/typography/H5/H5.tsx

function H5_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 20px;\n  line-height: 110%;\n  color: ",
        ";\n  font-style: normal;\n  margin: 12px 0;\n"
    ]);
    H5_templateObject = function() {
        return data;
    };
    return data;
}
function H5_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 700;\n"
    ]);
    H5_templateObject1 = function() {
        return data;
    };
    return data;
}
function H5_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 400;\n"
    ]);
    H5_templateObject2 = function() {
        return data;
    };
    return data;
}
function H5_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 300;\n"
    ]);
    H5_templateObject3 = function() {
        return data;
    };
    return data;
}



const BaseH5 = styled_components_browser_esm/* default.h5.withConfig */.ZP.h5.withConfig({
    componentId: "sc-11381ab3-0"
})(H5_templateObject(), (param)=>{
    let { theme , color  } = param;
    return theme.colors[color].normal;
});
const StyledH5Bold = (0,styled_components_browser_esm/* default */.ZP)(BaseH5).withConfig({
    componentId: "sc-11381ab3-1"
})(H5_templateObject1());
const StyledH5 = (0,styled_components_browser_esm/* default */.ZP)(BaseH5).withConfig({
    componentId: "sc-11381ab3-2"
})(H5_templateObject2());
const StyledH5Light = (0,styled_components_browser_esm/* default */.ZP)(BaseH5).withConfig({
    componentId: "sc-11381ab3-3"
})(H5_templateObject3());
function H5(param) {
    let { variant ="regular" , children , color ="black" , ...rest } = param;
    switch(variant){
        case "bold":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledH5Bold, {
                color: color,
                ...rest,
                children: children
            });
        case "regular":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledH5, {
                color: color,
                ...rest,
                children: children
            });
        case "light":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledH5Light, {
                color: color,
                ...rest,
                children: children
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledH5, {
                color: color,
                ...rest,
                children: children
            });
    }
}

;// CONCATENATED MODULE: ./components/typography/H6/H6.tsx

function H6_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 18px;\n  line-height: 100%;\n  color: ",
        ";\n  font-style: normal;\n  margin: 12px 0;\n"
    ]);
    H6_templateObject = function() {
        return data;
    };
    return data;
}
function H6_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 700;\n"
    ]);
    H6_templateObject1 = function() {
        return data;
    };
    return data;
}
function H6_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 400;\n"
    ]);
    H6_templateObject2 = function() {
        return data;
    };
    return data;
}
function H6_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 300;\n"
    ]);
    H6_templateObject3 = function() {
        return data;
    };
    return data;
}



const BaseH6 = styled_components_browser_esm/* default.h6.withConfig */.ZP.h6.withConfig({
    componentId: "sc-393658dd-0"
})(H6_templateObject(), (param)=>{
    let { theme , color  } = param;
    return theme.colors[color].normal;
});
const StyledH6Bold = (0,styled_components_browser_esm/* default */.ZP)(BaseH6).withConfig({
    componentId: "sc-393658dd-1"
})(H6_templateObject1());
const StyledH6 = (0,styled_components_browser_esm/* default */.ZP)(BaseH6).withConfig({
    componentId: "sc-393658dd-2"
})(H6_templateObject2());
const StyledH6Light = (0,styled_components_browser_esm/* default */.ZP)(BaseH6).withConfig({
    componentId: "sc-393658dd-3"
})(H6_templateObject3());
function H6(param) {
    let { variant ="regular" , children , color ="black" , ...rest } = param;
    switch(variant){
        case "bold":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledH6Bold, {
                color: color,
                ...rest,
                children: children
            });
        case "regular":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledH6, {
                color: color,
                ...rest,
                children: children
            });
        case "light":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledH6Light, {
                color: color,
                ...rest,
                children: children
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledH6, {
                color: color,
                ...rest,
                children: children
            });
    }
}

// EXTERNAL MODULE: ./components/typography/P/P.tsx
var P = __webpack_require__(73348);
// EXTERNAL MODULE: ./components/typography/TitleWithHighlights.tsx
var TitleWithHighlights = __webpack_require__(47804);
;// CONCATENATED MODULE: ./components/typography/index.tsx











/***/ }),

/***/ 46290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ parseHTMLtoReact; }
/* harmony export */ });
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25935);

function parseHTMLtoReact(html) {
    return (0,html_react_parser__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(html ? html : "");
}


/***/ })

}]);